<template>
  <v-app>
    <v-main>
      <v-container>
        <v-row class="justify-center">
          <v-col sm="8">
            <v-card>
              <div class="d-flex justify-center flex-wrap">
                <img src="https://archivos.demre.cl/public/logo_demre_200.png" class="pa-4">
                <img src="https://archivos.demre.cl/public/logo_subsecretaria_ed_200.png" class="pa-4">
              </div>
              <v-card-text class="text-center mt-4">
                <h3>Estimado usuario:</h3>
                <p>{{ mensaje }}</p>
              </v-card-text>
              <v-card-actions class="justify-center pb-6">
                <v-btn color="secondary" @click="$store.dispatch('session/logout')">
                  Salir
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>


<script>

export default {
  props: {
    mensaje: {
      type: String,
      default: '',
    },
  }
};
</script>
